import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import DonorList from './DonorList';
import useStore from '../useStore';

function LoadingIndicator() {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <div className="loading-label">Loading</div>
      </div>
    );
  }

function FiscalYearList({ agency, onBack  }) {
    const [loading, setLoading] = useState(true);
    const [years, setYears] = useState([]);  
    const [error, setError] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const setSelectedAgency = useStore((state) => state.setSelectedAgency);
        const { selectedAgency } = useStore();
    
        if (!selectedAgency) {
            setSelectedAgency(agency)
        }

    useEffect(() => {
        if (!agency && !selectedAgency) return;

        const currentAgency = selectedAgency || agency;

        setSelectedAgency(currentAgency);
        setLoading(true);

        axios.get(`${process.env.REACT_APP_API_URL}/Years?vendorid=${agency.vendorId}`) // Use relative path
            .then((response) => {
                const data = response.data;

                // Group data by fiscalYear, summing payments and keeping the max pledge total
                const groupedData = data.reduce((acc, curr) => {
                    const year = curr.fiscalYear;
                    const grossPayment = Number(curr.grossPayment) || 0;
                    const totalPledgeAmount = Number(curr.totalPledgeAmount) || 0;

                    if (!acc[year]) {
                        acc[year] = { ...curr, grossPayment: 0, totalPledgeAmount: 0 };
                    }
                    acc[year].grossPayment += grossPayment;
                    acc[year].totalPledgeAmount = Math.max(acc[year].totalPledgeAmount, totalPledgeAmount);
                    return acc;
                }, {});

                // Convert grouped data back to array format
                const dataWithIds = Object.values(groupedData).map((year, index) => ({
                    ...year,
                    id: year.id || index // Ensure each check has a unique id
                }));

                setYears(dataWithIds); 
            })
            .catch((error) => {
                if (error.response) {
                    console.log('Response error:', error.response.data);
                    setError(error.response.data);
                } else if (error.request) {
                    console.log('Request error:', error.request);
                    setError('No response received from server');
                } else {
                    console.log('General error:', error.message);
                    setError(error.message);
                }
                setLoading(false);
            })
            .finally(() => setLoading(false));
    }, [agency, selectedAgency]);

    if (loading) return <LoadingIndicator />;
    if (error) return <div>Error: {error.message}</div>;

    const columns = [
        { field: 'fiscalYear', headerName: 'Fiscal Year', width: 150, 
            renderCell: (params) => (
            <span style={{ color: 'red', cursor: 'pointer' }}>
                {params.value}
            </span>
        ) },
        { field: 'grossPayment', headerName: 'Total Amount Paid', width: 150,
            valueFormatter: (params) => {
            const v = parseFloat(params)
            return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          },},
          { field: 'totalPledgeAmount', headerName: 'Total Amount Pledged', width: 150,
            valueFormatter: (params) => {
            const v = parseFloat(params)
            return v.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          },},
        { field: 'desig', headerName: 'DesigCode', width: 150 }
    ];

    const handleRowClick = (params) => {
        setSelectedYear(params.row);
    };

    const columnVisibilityModel = {
        desig: false // Set this to false to hide the column
    };

    return (
        <div>
            {selectedYear ? (
                <DonorList year={selectedYear} onBack={() => setSelectedYear(null)} />
            ) : (
                <div style={{ height: 400, width: '100%' }}>
                    <button className="gradient-button" onClick={onBack}>Back to Agencies</button>
                    <h2>Fiscal Years for {agency.name}</h2>
                    <DataGrid
                        rows={years}
                        columns={columns}
                        pageSize={5}
                        onRowClick={handleRowClick}
                        columnVisibilityModel={columnVisibilityModel}
                    />
                </div>
            )}
        </div>
    );
}

export default FiscalYearList;
